import { UploadType } from '@wellesley/openapi'

export const getUploadType = (file: File): UploadType => {
  switch (true) {
    case file.type.includes('image'):
      return 'IMAGE'

    case file.type.includes('video'):
      return 'VIDEO'

    case file.type.includes('audio'):
      return 'AUDIO'

    default:
      return 'OTHER'
  }
}
